import { createSlotRecipe } from './runtime';

const hoverCardConfig = {"name":"hoverCard","slots":["arrow","arrowTip","trigger","positioner","content"]}

export const hoverCard = /* @__PURE__ */ createSlotRecipe(hoverCardConfig)